import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteData from 'components/list/Filters/types/autocomplete/AutoCompleteData';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';
import { Field } from 'redux-form';

const RenderAutoCompleteDataInputField = (props) => {
    const {
        fullWidth,
        input,
        input: {
            name,
        },
        label,
        minLength,
        optionValue,
        reference,
        searchBy,
        searchParams,
    } = props;

    return (
        <AutoCompleteData
            input={ input }
            minLength={ minLength }
            reference={ reference }
            searchBy={ searchBy }
            searchParams={ searchParams }
        >
            <Field
                component={ AutoCompleteField }
                fullWidth={ fullWidth }
                input={ input }
                label={ label }
                name={ name }
                optionText={ searchBy }
                optionValue={ optionValue }
            />
        </AutoCompleteData>
    );
};

RenderAutoCompleteDataInputField.defaultProps = {
    fullWidth: false,
    label: null,
    minLength: 3,
    optionValue: 'id',
    searchBy: 'title',
    searchParams: {
        size: '12',
        sort_by: 'title',
        sort_direction: 'asc',
    },
};

RenderAutoCompleteDataInputField.propTypes = {
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    minLength: PropTypes.number,
    optionValue: PropTypes.string,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    searchParams: PropTypes.shape({
        size: PropTypes.number,
        sort_by: PropTypes.string,
        sort_direction: PropTypes.oneOf([
            'asc',
            'desc',
        ]),
    }),
};

export default RenderAutoCompleteDataInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/AutoCompleteField/RenderAutoCompleteDataInputField.js